import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { FusePageSimple } from "@fuse";
import { withRouter } from "react-router";
import isEmpty from 'lodash/isEmpty';
import SelectAccountView from './SelectAccountView';
import EndpointsGetter from '../common/EndpointsGetter';
import axiosInstance from "../common/AxiosInstace";
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const styles = theme => ({
    layoutRoot: {}
});

class SelectAccount extends Component {
    state = {
        error: ''
    }

    componentDidMount() {
        if (isEmpty(this.props.location.state)) {
            this.props.history.goBack();
        } else {
            let cookieExpiry = Date.now() + 120 * 1000,
                userAccounts = this.props.location.state.userAccounts,
                cookieDomain = window.location.href.includes('test') ? '.dev.test' : '.kanin.io';

            cookies.set('user_accounts', userAccounts, { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
        }
    }

    setAccount = ({ id, accountUrl }) => {
        this.setState({ error: '' });
        let accessToken = this.props.location.state.accessToken;
        axiosInstance.put(`${EndpointsGetter.setUserAccountEndpoint()}/${id}`, {}, {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                const { access_token, expires_in, refresh_token } = response.data.tokenInfo,
                    cookieExpiry = Date.now() + 120 * 1000,
                    userCookieExpiry = Date.now() + 7200 * 1000,
                    url = window.location.href,
                    cookieDomain = url.includes('test') ? '.dev.test' : '.kanin.io';

                cookies.remove('user_accounts', { path: '/', domain: cookieDomain });
                cookies.set('access_token', access_token, { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
                cookies.set('refresh_token', refresh_token, { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
                cookies.set('expires_in', expires_in, { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
                cookies.set('set_in', new Date().getTime(), { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
                cookies.set('user', response.data.user, { path: '/', expires: new Date(userCookieExpiry), domain: cookieDomain });
                
                window.location.href = url.includes('test') ? `http://dev.test:3000/` : `https://${accountUrl}`;
            })
            .catch(error => {
                console.log('error: ', error.response);
                this.setError(error.response);
            })
    }

    setError = (error) => {
        this.setState({ error: error.data.message });
    }

    render() {
        const { classes } = this.props,
            userAccounts = this.props.location.state ? this.props.location.state.userAccounts : [],
            { error } = this.state;

        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                content={
                    <div className="p-24 m-auto" style={{ maxWidth: '960px' }}>
                        <h3> Your kanin accounts </h3>
                        <div style={{ color: '#ff4d4d', margin: '10px 0 5px 0', fontWeight: 600 }}>
                            {error ? error : ''}
                        </div>

                        <SelectAccountView
                            accounts={userAccounts}
                            setAccount={this.setAccount}
                        />
                    </div>
                }
            />
        )
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(SelectAccount));


// WEBPACK FOOTER //
// ./src/main/content/select-account/SelectAccount.js